// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2NY_K","productName":"Table_productName__1RDd9"};